import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ListCandidatesComponent } from './list-candidates/list-candidates.component';
import { StepsHeaderComponent } from './steps-header/steps-header.component';
import { HireComponent } from './hire/hire.component';
import { WizardComponent } from './wizard/wizard.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardsModule } from '../dashboards/dashboards.module';
import { CandidatesModule } from '../candidates/candidates.module';
import { MessagesModule } from '../messages/messages.module';
import { DiscussComponent } from './discuss/discuss.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { TaskWizardResolver } from './services/task-wizard-resolver';
import { CloseWizardComponent } from './close-wizard/close-wizard.component';

const routes : Routes = [
  { path: 'tasks-wizard', component: WizardComponent, resolve: { lookupdata: TaskWizardResolver } },
  { path: 'tasks-wizard/:jobId', component: WizardComponent, resolve: { lookupdata: TaskWizardResolver } }
]

@NgModule({
  declarations: [
    ListCandidatesComponent,
    StepsHeaderComponent,
    HireComponent,
    WizardComponent,
    DiscussComponent,
    CloseWizardComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    DashboardsModule,
    CandidatesModule,
    MessagesModule,
    NgxPayPalModule
  ]
})
export class TasksWizardModule { }
